import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    gridIcon: {
        paddingTop: 10,
        paddingRight: 10
     },
     gridTypography: {
        paddingTop: 15,
        paddingRight: 15
     } ,
     icon : {
        fontSize : 20
     }
  
}))
